/**
 * @module Directives.Paywalls
 *
 */
import template from 'ngapp/templates/views/paywalls/_space_limit_modal.html';
import spacelimit_icon_png from 'app/images/paywall-body-icon-space-limit.png';

/**
 * @class SpaceLimitModal
 *
 */
function Controller($scope, tracking) {
  $scope.modal = $scope.$props.modal;
  $scope.onCancel = onCancel;
  $scope.feature = 'Space Limit';
  $scope.spacelimit_icon_png = spacelimit_icon_png;

  tracking.paywalls.shown($scope.feature);

  function onCancel() {
    $scope.$props.modal.dismiss();
  }
}

Controller.$inject = ['$scope', 'core.services.tracking'];

export default {
  bindings: {
    modal: '<'
  },
  template,
  controller: Controller,
  controllerAs: '$props'
};
